import { render, staticRenderFns } from "./GhostwritersGraph.vue?vue&type=template&id=598cfc1e&"
import script from "./GhostwritersGraph.vue?vue&type=script&lang=js&"
export * from "./GhostwritersGraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports